import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	title: {
		id: 'b2b.eligibilityEnrollment.title',
		defaultMessage: 'Your {uniqueId}',
		description: 'UniqueId is a non-translated string that indicates the employee ID to enter',
	},
	instructions: {
		id: 'b2b.eligibilityEnrollment.instructions',
		defaultMessage:
			'Enter the {uniqueId} provided by {partnerName} to link your account and enable {planName}, free!',
		description: 'Instructions for how to enroll in Calm Premium via unique partner identification details',
	},
	alreadyRedeemed: {
		id: 'b2b.eligibilityEnrollment.alreadyRedeemed',
		defaultMessage:
			'The {uniqueId} you entered has already been redeemed. If you think there has been a mistake, please <supportlink>contact Calm’s Support team here.</supportlink>',
		description: 'Usser cannot redeem the offer a second time',
	},
	missingId: {
		id: 'b2b.eligibilityEnrollment.missingId',
		defaultMessage: 'The {uniqueId} you entered was not found.',
		description: 'Cannot find the id needed to redeem the offer',
	},
	requestAccess: {
		id: 'b2b.eligibilityEnrollment.requestAccess',
		defaultMessage: "Don't know your {uniqueId}? <accessLink>Request Access</accessLink>.",
		description:
			"Indicates the user should click the request access link if they don't know their partner user ID",
	},
	errorRequestAccess: {
		id: 'b2b.eligibilityEnrollment.errorRequestAccess',
		defaultMessage:
			'Oops! There was an error during redemption. Please <accessLink>Request Access</accessLink>.',
		description: "Indicates the user should click the request access after the one they typed in didn't work",
	},
	errorInvalidId: {
		id: 'b2b.eligibilityEnrollment.errorInvalidId',
		defaultMessage:
			"The {uniqueId} used is not on your organization's eligibility file. Please double-check for typos and contact your HR/benefits admin to confirm your eligibility.",
		description: 'Indicates the user entered an incorrect unique ID and should try again.',
	},
	errorInvalidOfferCode: {
		id: 'b2b.eligibilityEnrollment.errorInvalidOfferCode',
		defaultMessage: 'This offer code is not valid or has already been used',
		description: "Indicates the user's offer code is invalid",
	},
	errorInvalidGroupCode: {
		id: 'b2b.eligibilityEnrollment.errorInvalidGroupCode',
		defaultMessage: 'This group code is not valid. Please try again.',
		description: "Indicates the user's group code is invalid",
	},
	accesscode: {
		id: 'b2b.eligibility.descriptor.accessCode',
		defaultMessage: 'Access Code',
		description: 'the term Access Code',
	},
	offercodeCTA: {
		id: 'b2b.eligibility.descriptor.offerCodeCTA',
		defaultMessage: 'Enter your offer code',
		description: 'the phrase Enter Your Offer Code',
	},
	offercode: {
		id: 'b2b.eligibility.descriptor.offerCode',
		defaultMessage: 'Offer Code',
		description: 'the term Offer Code',
	},
	email: {
		id: 'b2b.eligibility.descriptor.email',
		defaultMessage: 'Email',
		description: 'the word Email',
	},
	employeeid: {
		id: 'b2b.eligibility.descriptor.employeeId',
		defaultMessage: 'Employee ID',
		description: 'the term Employee ID',
	},
	employeeemail: {
		id: 'b2b.eligibility.descriptor.employeeEmail',
		defaultMessage: 'Employee Email',
		description: 'the term Employee Email',
	},
	valuePropHeader: {
		id: 'b2b.account.valueproplist.header',
		defaultMessage: 'Activate your free Calm account',
		description: 'Value props of calm on the account screen',
	},
	validationError: {
		id: 'b2b.eligibilityEnrollment.validationError',
		defaultMessage: 'Please enter a valid {uniqueId}',
		description: 'Validation error message for invalid input',
	},
	instructionsRevamp: {
		id: 'b2b.eligibilityEnrollment.instructionsRevamp',
		defaultMessage:
			'Please enter the {uniqueId} provided by your organization. You can find this code in materials sent to you by your organization.',
		description: 'Instructions for how to enroll in Calm Premium via unique partner identification details',
	},
	titleRevamp: {
		id: 'b2b.eligibilityEnrollment.titleRevamp',
		defaultMessage: 'Enter your {uniqueId}',
		description: 'UniqueId is a non-translated string that indicates the employee ID to enter',
	},
});
